import { Box, Skeleton, TextField } from "@mui/material";

const TestComponent = () => {
    return (
        <Box width="100%" height="100%" display="flex" justifyContent="center" alignContent="center">
            <Skeleton variant="rounded" width={100} height={100} />
            <TextField id="outlined-basic" label="Outlined" variant="outlined" sx={{}} />
        </Box>
    )
}

export default TestComponent;